module.exports = __webpack_public_path__ + "static/media/tv-bw.943c6000.png";